import React from 'react';
import { IconButton } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import { useTheme } from '@mui/system';
import trackUse from '@utils/trackUse';
import { logPostHogEvent } from '@utils/index';
import colors from '@utils/colors';

interface ShareButtonProps {
  url: string;
  title: string;
}

const ShareButton = ({ url, title }: ShareButtonProps) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const shareUrl = () => {
    trackUse({
      item: 'share-button',
      value: url,
      type: 'SHARE'
    });

    logPostHogEvent('share-button', {
      item: 'share-button',
      value: url,
      type: 'CLICK'
    });

    if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
      navigator
        ?.share({
          title,
          url
        })
        .then(() => console.log('Successful share'))
        .catch((error) => console.log('Error sharing', error));
    }
  };

  // Check if Web Share API is supported
  const isSupported =
    typeof window !== 'undefined' && typeof navigator !== 'undefined'
      ? !!navigator?.share
      : false;

  return isSupported ? (
    <div style={{ display: 'block', textAlign: 'right' }}>
      <IconButton
        color="primary"
        aria-label="share"
        style={{
          color: isDarkMode ? theme.palette.linkColor : colors.jdbPurple
        }}
        onClick={shareUrl}
      >
        <ShareIcon />
      </IconButton>
    </div>
  ) : null;
};

export default ShareButton;
